import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router } from '@angular/router';
import { LoginService } from '../../../services/login.service';
import { DB_User } from '../../../interfaces/user';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { openSnackBar } from '../../../helpers/genericFunctions';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatDivider } from "@angular/material/divider";
import { map, Observable, startWith } from 'rxjs';
import { globalUser } from '../../../helpers/globalFields';
import { MatAutocompleteModule, MatAutocompleteTrigger } from '@angular/material/autocomplete';

/**
 * Login screen component
 */
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    NgIf,
    NgFor,
    MatIcon,
    MatSelectModule,
    CommonModule,
    MatDivider,
    MatAutocompleteModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  /**
   * constructor
   *
   * @param formBuilder formBuilder to make use of angulars form checks and autocomplete features
   * @param router angular router to automatically load the ticket overview once logged in
   * @param loginService connection to the authentication api
   * @param snackBar overlay to display errors if necessairy
   */
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private snackBar: MatSnackBar,
  ) { }

  organizationList: { org_id: number; org_name: string }[] = [];
  filteredOrganizations$!: Observable<{ org_id: number; org_name: string }[]>;
  /**
   * while logging in the user should be prompted with a loading image. This is used to trigger
   * the change from default page to "currently waiting for the server to respond".
   */
  loggingIn = false;
  /**
   * toggle between default hidden password and showing it to check for mistakes
   */
  hidePassword = true;
  /**
   * toggles the visibility of the organization selection
   */
  showOrgListArrow = false;
  showOrgList = false;
  /**
   * login form that interacts with login service
   *
   * @param usr_NAME user name of login
   * @param usr_PASSWORD user password for login
   */
  loginForm = this.formBuilder.group({
    usr_NAME: new FormControl('', Validators.required),
    usr_PASSWORD: new FormControl('', Validators.required),
    org_name: new FormControl(''),
  });


  /**
   * Submits user credentials to authentication API. Receives an access token upon positive answer and adds
   * the token to all components that need to authenticate themselves at the database api.
   */
  onLogin(): void {
    let loginUser: DB_User = {
      usr_NAME: this.loginForm.value.usr_NAME || '',
      usr_PASSWORD: this.loginForm.value.usr_PASSWORD || '',
      org_name: this.loginForm.value.org_name || '',
    };
    this.loggingIn = true;
    this.loginService.login(loginUser).subscribe(
      (response) => {
        if (response.length > 1) {
          this.showOrgListArrow = true;
          this.organizationList = (
            response as {
              org_id: number;
              org_name: string;
            }[]
          ).map(({ org_id, org_name }) => ({
            org_id,
            org_name,
          }));
          this.loginForm.controls["org_name"].setValue(this.organizationList[0].org_name);
          
        }
        else {
          globalUser.setToken(response.accessToken, response.refreshToken);
          this.router.navigate(["pTickets/list"]);
        }
        this.loggingIn = false;
      },
      (error) => {
        this.loggingIn = false;
        openSnackBar(error.error, 5000, this.snackBar);
      },
    );
  }
  /**
   * navigates the register component.
   */
  onRegister(): void {
    this.router.navigate(['register']);
  }
}
